// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_header__6gPPp {
  font-size: 30px;
  color: rgb(94, 219, 221);
  text-align: center;
  position: absolute;
  left: 50%;
  right: 0;
  height: -moz-fit-content;
  height: fit-content;
  margin-left: 50px;
  margin-right: 50px;
  margin-top: 20%;
}

.Home_picture__okd02 {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.Home_title_lines_function__FtsqL {
  position: relative;
  font-size: 30px;
  z-index: 1;
  overflow: hidden;
  text-align: center;
  color: #0a0a0af8;
  font-family: arial;
  font-family: var(--app-header-font);
  font-weight: bold;
}
.Home_title_lines_function__FtsqL:before,
.Home_title_lines_function__FtsqL:after {
  position: absolute;
  top: 51%;
  overflow: hidden;
  width: 48%;
  height: 5px;
  content: "\\a0";
  background-color: black;
  margin-left: 2%;
}
.Home_title_lines_function__FtsqL:before {
  margin-left: -50%;
  text-align: right;
}

.Home_titleFunctionDiv__EPIJV {
  padding: 50px 0;
}

.Home_title_lines_ethios__1YzCr {
  position: relative;
  font-size: 30px;
  z-index: 1;
  overflow: hidden;
  text-align: center;
  color: #0a0a0af8;
  font-family: var(--app-header-font);
  font-weight: bold;
}
.Home_title_lines_ethios__1YzCr:before,
.Home_title_lines_ethios__1YzCr:after {
  position: absolute;
  top: 26%;
  overflow: hidden;
  width: 48%;
  height: 5px;
  content: "\\a0";
  background-color: black;
  margin-left: 2%;
}
.Home_title_lines_ethios__1YzCr:before {
  margin-left: -50%;
  text-align: right;
}

.Home_titleEthiosDiv__d0RH\\+ {
  padding: 0px 0px 40px 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,wBAAmB;EAAnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".header {\n  font-size: 30px;\n  color: rgb(94, 219, 221);\n  text-align: center;\n  position: absolute;\n  left: 50%;\n  right: 0;\n  height: fit-content;\n  margin-left: 50px;\n  margin-right: 50px;\n  margin-top: 20%;\n}\n\n.picture {\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n}\n\n.title_lines_function {\n  position: relative;\n  font-size: 30px;\n  z-index: 1;\n  overflow: hidden;\n  text-align: center;\n  color: #0a0a0af8;\n  font-family: arial;\n  font-family: var(--app-header-font);\n  font-weight: bold;\n}\n.title_lines_function:before,\n.title_lines_function:after {\n  position: absolute;\n  top: 51%;\n  overflow: hidden;\n  width: 48%;\n  height: 5px;\n  content: \"\\a0\";\n  background-color: black;\n  margin-left: 2%;\n}\n.title_lines_function:before {\n  margin-left: -50%;\n  text-align: right;\n}\n\n.titleFunctionDiv {\n  padding: 50px 0;\n}\n\n.title_lines_ethios {\n  position: relative;\n  font-size: 30px;\n  z-index: 1;\n  overflow: hidden;\n  text-align: center;\n  color: #0a0a0af8;\n  font-family: var(--app-header-font);\n  font-weight: bold;\n}\n.title_lines_ethios:before,\n.title_lines_ethios:after {\n  position: absolute;\n  top: 26%;\n  overflow: hidden;\n  width: 48%;\n  height: 5px;\n  content: \"\\a0\";\n  background-color: black;\n  margin-left: 2%;\n}\n.title_lines_ethios:before {\n  margin-left: -50%;\n  text-align: right;\n}\n\n.titleEthiosDiv {\n  padding: 0px 0px 40px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Home_header__6gPPp`,
	"picture": `Home_picture__okd02`,
	"title_lines_function": `Home_title_lines_function__FtsqL`,
	"titleFunctionDiv": `Home_titleFunctionDiv__EPIJV`,
	"title_lines_ethios": `Home_title_lines_ethios__1YzCr`,
	"titleEthiosDiv": `Home_titleEthiosDiv__d0RH+`
};
export default ___CSS_LOADER_EXPORT___;
